/**
 * @sync-target レクシンユーザーメッセージ一覧 > 05_静的ページメッセージ
 */
export const STATIC_PAGE_MESSAGES = {
  NOT_FOUND: "404 - お探しのページは見つかりませんでした。",
  SPACE_NOT_FOUND: "スペースが見つかりませんでした",
  LOADING: "読み込み中...",
  REVERSE_ENGINEERING_PROCESSING_DELAY_WARNING:
    "処理に時間がかかっています。しばらくお待ちください。",
  SIGNUP_CLOSED_TITLE: "新規登録受付終了のお知らせ",
  SIGNUP_CLOSED_BODY:
    "「レクシン AI for kintone」は、2027年1月29日（金）をもちましてサービスの提供を終了いたします。\nこれに伴い、2026年10月29日（木）をもちまして新規登録の受付を終了いたしました。\nこれまでご愛顧いただき、誠にありがとうございました。",
} as const;
